import type { ReactNode } from "react";

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  action,
}: {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  action?: ReactNode;
}) {
  const isCenter = align === "center";
  return (
    <div
      className={`flex flex-col ${
        isCenter ? "items-center text-center" : "md:flex-row md:items-end md:justify-between"
      } gap-4 mb-8 md:mb-10`}
    >
      <div className={isCenter ? "max-w-2xl" : "max-w-2xl"}>
        {eyebrow && (
          <p className="flex items-center gap-2 text-xs font-medium tracking-[0.24em] uppercase text-primary-600 mb-3">
            {isCenter ? null : <span className="w-6 h-px bg-primary-400" aria-hidden="true"></span>}
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
          {title}
        </h2>
        {desc && (
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}